// @bend-expect ban-forbidden-imports
import { ErrorBoundary as _ErrorBoundary } from 'fail-safe/ErrorBoundary';
// @bend-expect ban-forbidden-imports
export type { ErrorBoundaryProps, ErrorComponentProps } from 'fail-safe/ErrorBoundary';

class _ErrorBoundaryWithCallerPackage extends _ErrorBoundary {
  protected get failSafeCallerPackage(): string {
    return 'marketplace-embed';
  }
}

export { _ErrorBoundaryWithCallerPackage as ErrorBoundary };
